import Vue from "vue";
import VueJsModal from "vue-js-modal";
import App from "./App.vue";
import router from "./router";

import axios from "axios";
Vue.prototype.$axios = axios;

import store from "@/store";

import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "vue-multiselect/dist/vue-multiselect.min.css";

import "./assets/css/style.css";

import "@/mixins/DeviceDetectMixin";

import en from "vee-validate/dist/locale/en";
import es from "vee-validate/dist/locale/es";
import id from "vee-validate/dist/locale/id";
import VeeValidate, { Validator } from "vee-validate";

Vue.use(VeeValidate);
if (i18n.locale === "es") {
  Validator.localize("es", es);
} else if (i18n.locale === "id") {
  Validator.localize("id", id);
} else {
  Validator.localize("en", en);
}

import { BootstrapVue } from "bootstrap-vue";

import LayoutDefault from "@/layouts/LayoutDefault.vue";
import i18n from "./i18n";

Vue.component("layout-default", LayoutDefault);

Vue.config.productionTip = false;
Vue.prototype.publicPath = process.env.BASE_URL;

Vue.use(BootstrapVue);
Vue.use(VueJsModal, {
  dialog: true,
  dynamicDefaults: {
    draggable: true
  }
});

axios.interceptors.request.use(
  conf => {
    document.getElementById("loader").style.display = "block";
    return conf;
  },
  error => {
    document.getElementById("loader").style.display = "none";
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    document.getElementById("loader").style.display = "none";
    return response;
  },
  error => {
    document.getElementById("loader").style.display = "none";
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  created() {
    const userString = localStorage.getItem("user");
    if (userString) {
      const userData = JSON.parse(userString);
      this.$store.commit("SET_USER_DATA", userData);
    }
  },
  i18n,
  render: h => h(App)
}).$mount("#app");
